import axios from "../../config/interceptor";

export const postRefoundUsedBalance = async (data) => {
  try {
    let link = `/lambda/v1/refound-used-balance`;
    const response = await axios.post(link, data);
    return response;
  } catch (error) {
    return error;
  }
};
